import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { ICommunityEngagementFormM24 } from 'legacy/lut/classes/models/hpAmplifyInitiativesForms/ICommunityEngagementFormM24'
import { IComRepFormM05 } from 'legacy/lut/classes/models/hpAmplifyInitiativesForms/IComRepFormM05'
import { ICustomerAwarenessFormM11 } from 'legacy/lut/classes/models/hpAmplifyInitiativesForms/ICustomerAwarenessFormM11'
import { IEmployeeWellBeingFormM21 } from 'legacy/lut/classes/models/hpAmplifyInitiativesForms/IEmployeeWellBeingFormM21'
import { IEnergyEfficiencyFormM16 } from 'legacy/lut/classes/models/hpAmplifyInitiativesForms/IEnergyEfficiencyFormM16'
import { IExecutiveSponsorshipFormM01 } from 'legacy/lut/classes/models/hpAmplifyInitiativesForms/IExecutiveSponsorshipFormM01'
import { IOfficeRecyclingFormM14 } from 'legacy/lut/classes/models/hpAmplifyInitiativesForms/IOfficeRecyclingFormM14'
import { ISustainabilityDealFormM07 } from 'legacy/lut/classes/models/hpAmplifyInitiativesForms/ISustainabilityDealFormM07'
import { IUserInitiativesForm } from 'legacy/lut/classes/models/hpAmplifyInitiativesForms/IUserInitiativesForm'
import { IVolunteeringFormM22 } from 'legacy/lut/classes/models/hpAmplifyInitiativesForms/IVolunteeringFormM22'
import { IActivityLog } from 'legacy/lut/classes/models/IActivityLog'
import { IContactActual } from 'legacy/lut/classes/models/IContactActual'
import { ICoverage } from 'legacy/lut/classes/models/ICoverage'
import {
  IContactCodeLog,
  IContactsExt,
  IPartnerCodeLog,
  IPartnersExt,
} from 'legacy/lut/classes/models/IFormCodeLog'
import { IFormCodesDictionary } from 'legacy/lut/classes/models/IFormCodesDictionary'
import { IFormComments } from 'legacy/lut/classes/models/IFormComments'
import { IFormContactCampaigns } from 'legacy/lut/classes/models/IFormContactCampaigns'
import { IFormLeadAbout } from 'legacy/lut/classes/models/IFormLeadAbout'
import { IFormPartnerFlagsRequests } from 'legacy/lut/classes/models/IFormPartnerFlagsRequests'
import { IFormPartners, IFormPartnersList } from 'legacy/lut/classes/models/IFormPartners'
import { IFormPartnersExt } from 'legacy/lut/classes/models/IFormPartnersExt'
import { IFormProfile } from 'legacy/lut/classes/models/IFormProfile'
import { IFormProfileExt } from 'legacy/lut/classes/models/IFormProfileExt'
import { IFormProfilingAudience } from 'legacy/lut/classes/models/IFormProfilingAudience'
import { IFormSalesTeam } from 'legacy/lut/classes/models/IFormSalesTeam'
import { IFormSalesTeamLogs } from 'legacy/lut/classes/models/IFormSalesTeamLogs'
import { IFormToolAccessPartnerFlags } from 'legacy/lut/classes/models/IFormToolAccessPartnerFlags'
import { IFormTools } from 'legacy/lut/classes/models/IFormTools'
import { IFormUserRights } from 'legacy/lut/classes/models/IFormUserRights'
import { IImpactAssessment } from 'legacy/lut/classes/models/IImpactAssessment'
import { IImpactPledge } from 'legacy/lut/classes/models/IImpactPledge'
import { IPartnerActualData } from 'legacy/lut/classes/models/IPartnerActualData'
import { IProfilingTicket } from 'legacy/lut/classes/models/IProfilingTicket'
import { ISustainabilityAttachment } from 'legacy/lut/classes/models/ISustainabilityAttachment'
import { ISustainabilityPlan } from 'legacy/lut/classes/models/ISustainabilityPlan'
import { ISustainabilityPlanItems } from 'legacy/lut/classes/models/ISustainabilityPlanItems'
import { IToDoWidgetData } from 'legacy/lut/classes/models/IToDoWidgetData'
import {
  IAutoCheckCalculateStats,
  IAutoCheckStats,
} from 'legacy/lut/classes/models/onboarding/AutoCheckStats'
import { IThirdPartyDetailReport } from 'legacy/lut/classes/models/onboarding/ThirdPartyDetailReport'
import BusinessProfileStoreService from 'legacy/lut/classes/services/BusinessProfileStoreService'
import { CrudConnectors } from 'legacy/lut/classes/services/CrudConnectors'
import { BusinessOpportunityFinderApiFetcher } from 'legacy/lut/classes/services/fetcher/BusinessOpportunityFinderApiFetcher'
import { PartnerAllDataRegionsFetcher } from 'legacy/lut/classes/services/fetcher/PartnerAllDataRegionsFetcher'
import { SearchAPIFetcher } from 'legacy/lut/classes/services/fetcher/SearchAPIFetcher'
import { partnerDataStoreService } from 'legacy/lut/classes/services/PartnerDataStoreService'
import { ILegalAttachment } from 'legacy/lut/components/widgets/public/partnerEditDialog/models'
import { IFormCertification } from 'legacy/lut/components/widgets/public/pfEligibility/models/IFormCertification'
import { IFormStatusAccred } from 'legacy/lut/components/widgets/public/pfEligibility/models/IFormStatusAccred'
import { IFormStatusCert } from 'legacy/lut/components/widgets/public/pfEligibility/models/IFormStatusCert'
import { IFormStatusCertEmp } from 'legacy/lut/components/widgets/public/pfEligibility/models/IFormStatusCertEmp'
import { IFormStatusOther } from 'legacy/lut/components/widgets/public/pfEligibility/models/IFormStatusOther'
import { IFormStatusOverall } from 'legacy/lut/components/widgets/public/pfEligibility/models/IFormStatusOverall'
import { IFormStatusRevenue } from 'legacy/lut/components/widgets/public/pfEligibility/models/IFormStatusRevenue'

import {
  I394Form,
  I495Form,
  I678Form,
  I721Form,
  I871Form,
  I935Form,
  I2010Form,
  I2029Form,
  I2034Form,
  I2070Form,
  I2079Form,
  I2081Form,
} from 'clickNgo/models/crud/forms'
import {
  IAgreementReportView,
  ICnGBusinessDetailsView,
  ICnGContactFlagsDataChangeView,
  ICnGContactsDataChangeView,
  ICnGPartnerDataChangeView,
  ICnGPartnerFlagsDataChangeView,
  IDistributorsOnBehalfView,
  IPartnerLnRStatusesView,
  ISalesTeamPBMsListView,
  ISalesTeamRequestsView,
  ISalesTeamTicketsView,
  IWW_SalesTeamLogsWithChangesView,
} from 'clickNgo/models/crud/views'
import { IPartnerMissedContactsView } from 'clickNgo/models/crud/views'
import { IAttachment } from 'clickNgo/models/file'
import { IForm } from 'core-components/classes/models/IForm'
import { Static } from 'core-components/types'
import { Logic, Operator } from 'core-components/types'
import { getAppId } from 'core/classes/helpers/getAppId'
import { IFetchResult } from 'core/classes/helpers/store/Interfaces'
import { ICountryHierarchyInformation } from 'core/classes/models/ICountryHierarchyInformation'
import { ILogForm } from 'core/classes/models/LogFormModel'
import { roleApi } from 'core/classes/services/api/RoleApi'
import { Crud } from 'core/types/Crud'
import { CrudInnerStorageFetcher } from 'core/types/CrudInnerStorageFetcher'
import { CrudStore } from 'core/types/crudStore'
import { ProcedureInnerStorageFetcher } from 'core/types/ProcedureInnerStorageFetcher'
import { thirdPartyLogsApi } from 'onboarding/api/thirdPartyLogsApi'
import { isFilter } from 'onboarding/utils/common'

import { IMarketingCampaignFormM11_1 } from '../models/hpAmplifyInitiativesForms/IMarketingCampaignFormM11_1'
import { IPrintFleetAssessmentFormM09 } from '../models/hpAmplifyInitiativesForms/IPrintFleetAssessmentFormM09'
import { ISustainableProcurementFormM02 } from '../models/hpAmplifyInitiativesForms/ISustainableProcurementFormM02'

import { IRegistrationData } from './api/RegistrationDataApi'
import { SearchRequestType } from './api/SearchApi'
import { GetSustainabilityFormKey } from './GetSustainabilityFormKey'

class InitializationService {
  public init = () => {
    CrudStore.add(
      new Crud<IAutoCheckStats>({
        fetcher: new CrudInnerStorageFetcher<IAutoCheckStats>('EntryId', {
          formId: 711,
          code: 'AutoCheckStatistic',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 100,
        },
        defaultSort: {
          field: 'EntryId',
          dir: 'desc',
        },
      }),
      CrudStoreItem.AutoCheckStatistic
    )
    CrudStore.add(
      new Crud<IAutoCheckCalculateStats>({
        fetcher: new CrudInnerStorageFetcher<IAutoCheckCalculateStats>('TotalChecks', {
          formId: 711,
          code: 'AutoCheckStatView',
        }),
        keyField: 'TotalChecks',
        defaultPaging: {
          page: 0,
          pageSize: 1,
        },
      }),
      CrudStoreItem.AutoCheckCalculateStats
    )
    CrudStore.add(
      new Crud<IFormPartners>({
        fetcher: new PartnerAllDataRegionsFetcher<IFormPartners>('EntryID', {
          formId: 261,
          code: 'PartnerAllDataRegions',
        }),
        keyField: 'EntryID',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
        connectorCreateFn: CrudConnectors.updatePartnerAllData,
        connectorUpdateFn: CrudConnectors.updatePartnerAllData,
        connectorDeleteFn: CrudConnectors.deletePartnerAllData,
        connectorFetchFn: partnerDataStoreService.fetchConnector,
      }),
      CrudStoreItem.PartnerAllData
    )
    CrudStore.add(
      new Crud<IFormPartners>({
        fetcher: new CrudInnerStorageFetcher<IFormPartners>('EntryID', {
          formId: 261,
          code: 'PartnerTree',
        }),
        keyField: 'EntryID',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.PartnerTree
    )
    CrudStore.add(
      new Crud<IFormPartners>({
        fetcher: new CrudInnerStorageFetcher<any>('partnerId', {
          formId: 261,
          code: 'PartnerBranchesCount',
        }),
        keyField: 'partnerId',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.PartnerBranchesCount
    )
    CrudStore.add(
      new Crud<IFormPartners>({
        fetcher: new CrudInnerStorageFetcher<IFormPartners>('EntryID', {
          formId: 261,
          code: 'PartnersSearch',
        }),
        keyField: 'EntryID',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.PartnersSearch
    )
    CrudStore.add(
      new Crud<IFormPartners>({
        fetcher: new CrudInnerStorageFetcher<IFormPartners>('EntryID', {
          formId: 261,
          code: 'PartnersSearchFilteredByCode',
        }),
        keyField: 'EntryID',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.PartnersSearchFilteredByCode
    )
    CrudStore.add(
      new Crud<IPartnerMissedContactsView>({
        fetcher: new CrudInnerStorageFetcher<IPartnerMissedContactsView>('PartnerId', {
          formId: 261,
          code: 'PartnerMissedContacts',
        }),
        keyField: 'PartnerId',
        defaultPaging: {
          page: 0,
          pageSize: 100,
        },
      }),
      CrudStoreItem.PartnerMissedContacts
    )
    CrudStore.add(
      new Crud<I394Form>({
        fetcher: new CrudInnerStorageFetcher<I394Form>('EntryId', {
          formId: 394,
          code: CrudStoreItem.PromosCustomerInfo,
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 100,
        },
      }),
      CrudStoreItem.PromosCustomerInfo
    )
    CrudStore.add(
      new Crud<ICnGBusinessDetailsView>({
        fetcher: new CrudInnerStorageFetcher<ICnGBusinessDetailsView>('PartnerId', {
          formId: 708,
          code: 'cng-business-details',
        }),
        keyField: 'PartnerId',
        defaultPaging: {
          page: 0,
          pageSize: 100,
        },
      }),
      CrudStoreItem.PartnerONBBusinessDetails
    )
    CrudStore.add(
      new Crud<I2034Form>({
        fetcher: new CrudInnerStorageFetcher<I2034Form>('EntryId', {
          formId: 2034,
          code: CrudStoreItem.PartnerBusinessDetails,
        }),
        keyField: 'PartnerId',
        defaultPaging: {
          page: 0,
          pageSize: 100,
        },
      }),
      CrudStoreItem.PartnerBusinessDetails
    )
    CrudStore.add(
      new Crud<IFormPartnersExt>({
        fetcher: new CrudInnerStorageFetcher<IFormPartnersExt>('EntryId', {
          formId: 406,
          code: 'PartnersExt',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItem.NewPartners
    )
    CrudStore.add(
      new Crud<IFormPartners>({
        fetcher: new CrudInnerStorageFetcher<IFormPartners>('EntryID', {
          formId: 261,
          code: 'OpenedPartnerRequests',
        }),
        keyField: 'EntryID',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
        connectorFetchFn: partnerDataStoreService.fetchConnector,
      }),
      CrudStoreItem.OpenedPartnerRequests
    )
    CrudStore.add(
      new Crud<I721Form>({
        fetcher: new CrudInnerStorageFetcher<I721Form>('EntryID', {
          formId: 721,
          code: CrudStoreItem.LNDRForm,
        }),
        keyField: 'EntryID',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.LNDRForm
    )
    CrudStore.add(
      new Crud<IFormPartners>({
        fetcher: new CrudInnerStorageFetcher<IFormPartners>('EntryId', {
          formId: 261,
          code: 'PartnerRequestProfiling',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.PartnerRequestProfiling
    )
    CrudStore.add(
      new Crud<IFormPartners>({
        fetcher: new CrudInnerStorageFetcher<IFormPartners>('EntryID', {
          formId: 261,
          code: 'LegalPartnerRequests',
        }),
        keyField: 'EntryID',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
        connectorFetchFn: partnerDataStoreService.fetchConnector,
      }),
      CrudStoreItem.LegalPartnerRequests
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new CrudInnerStorageFetcher<IForm>('EntryId', {
          formId: 514,
          code: 'UserRightsRequests',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 100,
        },
        defaultSort: { field: 'ContactId', dir: 'asc' },
        connectorCreateFn: CrudConnectors.createContactCodeRequests,
      }),
      CrudStoreItem.ContactCodeRequests
    )
    CrudStore.add(
      new Crud<IFormTools>({
        fetcher: new CrudInnerStorageFetcher<IFormTools>('EntryId', {
          formId: 578,
          code: 'WW_User_Tools_Access',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.WW_UserToolsAccess
    )
    CrudStore.add(
      new Crud<IFormCodesDictionary>({
        fetcher: new CrudInnerStorageFetcher<IFormCodesDictionary>('EntryId', {
          formId: 515,
          code: 'CodesDictionary',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 10000,
        },
        connectorCreateFn: CrudConnectors.createCodesDictionary,
      }),
      CrudStoreItem.CodesDictionary
    )
    CrudStore.add(
      new Crud<IFormCodesDictionary>({
        fetcher: new CrudInnerStorageFetcher<IFormCodesDictionary>('EntryId', {
          formId: 515,
          code: 'CodesDictionary',
        }),
        keyField: 'CodeName',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.CodesDictionaryByCodeName
    )
    CrudStore.add(
      new Crud<IFormCodesDictionary>({
        fetcher: new CrudInnerStorageFetcher<IFormCodesDictionary>('EntryId', {
          formId: 515,
          code: 'CodesDictionary',
        }),
        keyField: 'Code',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.CodesDictionaryByCode
    )
    CrudStore.add(
      new Crud<IFormContactCampaigns>({
        fetcher: new CrudInnerStorageFetcher<IFormContactCampaigns>('EntrtyID', {
          formId: 579,
          code: 'WW_ContactCampaigns',
        }),
        keyField: 'EntrtyID',
      }),
      CrudStoreItem.WW_ContactCampaigns
    )
    CrudStore.add(
      new Crud<IFormUserRights>({
        fetcher: new CrudInnerStorageFetcher<IFormUserRights>('EntrtyID', {
          formId: 580,
          code: 'UserRightSearchContacts',
        }),
        defaultSort: { field: 'USER_RIGHTS', dir: 'asc' },
        keyField: 'EntrtyID',
        defaultPaging: {
          page: 0,
          pageSize: 15,
        },
      }),
      CrudStoreItem.WW_UserRights
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new CrudInnerStorageFetcher<IForm>('PartnerId', {
          formId: 590,
          code: 'JBPMyPartners',
        }),
        keyField: 'PartnerId',
        defaultPaging: {
          page: 0,
          pageSize: 100,
        },
      }),
      CrudStoreItem.FavoritePartners
    )
    CrudStore.add(
      new Crud<IFormProfile>({
        fetcher: new CrudInnerStorageFetcher<IFormProfile>('EntryID', {
          formId: 261,
          code: 'ContactAllDataRegions',
        }),
        keyField: 'EntryID',
        connectorCreateFn: (formId: string, items: IForm[]) =>
          CrudConnectors.updateContactAllData(formId, items, true),
        connectorUpdateFn: CrudConnectors.updateContactAllData,
        connectorDeleteFn: CrudConnectors.deleteContactAllData,
        connectorFetchFn: BusinessProfileStoreService.fetchConnector,
      }),
      CrudStoreItem.ContactAllData
    )
    CrudStore.add(
      new Crud<IFormProfile>({
        fetcher: new CrudInnerStorageFetcher<IFormProfile>('EntryID', {
          formId: 261,
          code: 'OpenedContactRequests',
        }),
        keyField: 'EntryID',
        connectorFetchFn: BusinessProfileStoreService.fetchConnector,
      }),
      CrudStoreItem.OpenedContactRequests
    )
    CrudStore.add(
      new Crud<IFormProfile>({
        fetcher: new CrudInnerStorageFetcher<IFormProfile>('EntryId', {
          formId: 261,
          code: 'ContactRequestProfiling',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.ContactRequestProfiling
    )
    CrudStore.add(
      new Crud<IProfilingTicket>({
        fetcher: new CrudInnerStorageFetcher<IProfilingTicket>('EntryId', {
          formId: 955,
          code: 'ProfilingTicket-User',
        }),
        keyField: 'EntryId',
        skipPagingTransform: true,
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItem.ProfilingTicket
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('Id', {
          formId: 955,
          code: 'LOG_FORM_955',
        }),
        keyField: 'Id',
        defaultSort: { field: 'DateTime', dir: 'asc' },
      }),
      CrudStoreItem.TicketChanges
    )
    CrudStore.add(
      new Crud<I935Form>({
        fetcher: new CrudInnerStorageFetcher<I935Form>('EntryId', {
          formId: 935,
          code: CrudStoreItem.ToolAccessConditions,
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.ToolAccessConditions
    )
    CrudStore.add(
      new Crud<I2070Form>({
        fetcher: new CrudInnerStorageFetcher<I2070Form>('EntryId', {
          formId: 2070,
          code: CrudStoreItem.ToolsCodeRules,
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.ToolsCodeRules
    )
    CrudStore.add(
      new Crud<ICnGPartnerDataChangeView>({
        fetcher: new CrudInnerStorageFetcher<ICnGPartnerDataChangeView>('EntryId', {
          formId: 261,
          code: CrudStoreItem.CnGPartnerDataChange,
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.CnGPartnerDataChange
    )
    CrudStore.add(
      new Crud<ICnGPartnerFlagsDataChangeView>({
        fetcher: new CrudInnerStorageFetcher<ICnGPartnerFlagsDataChangeView>('EntryId', {
          formId: 261,
          code: CrudStoreItem.CnGPartnerFlagsDataChange,
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.CnGPartnerFlagsDataChange
    )
    CrudStore.add(
      new Crud<ICnGContactsDataChangeView>({
        fetcher: new CrudInnerStorageFetcher<ICnGContactsDataChangeView>('EntryId', {
          formId: 261,
          code: CrudStoreItem.CnGContactsDataChange,
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.CnGContactsDataChange
    )
    CrudStore.add(
      new Crud<ICnGContactFlagsDataChangeView>({
        fetcher: new CrudInnerStorageFetcher<ICnGContactFlagsDataChangeView>('EntryId', {
          formId: 261,
          code: CrudStoreItem.CnGContactFlagsDataChange,
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.CnGContactFlagsDataChange
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('PartnerID', {
          formId: 575,
          code: 'PartnerInactiveWithAuditFlags',
        }),
        keyField: 'PartnerID',
      }),
      CrudStoreItem.PartnerInactiveWithAuditFlags
    )
    CrudStore.add(
      new Crud<IFormProfileExt>({
        fetcher: new CrudInnerStorageFetcher<IFormProfileExt>('EntryId', {
          formId: 375,
          code: 'ContactExt',
        }),
        keyField: 'EntryId',
        defaultFilter: {
          logic: Logic.AND,
          filters: [
            {
              field: 'ContactID',
              operator: Operator.CONTAINS,
              value: 'new-',
            },
          ],
        },
        connectorCreateFn: (formId: string, items: IForm[]) =>
          CrudConnectors.createData(formId, items, CrudStoreItem.ContactExt),
      }),
      CrudStoreItem.ContactExt
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new CrudInnerStorageFetcher<IForm>('EntryID', {
          formId: 348,
          code: 'Call Outcome History',
        }),
        keyField: 'EntryID',
      }),
      CrudStoreItem.CallOutcome
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new CrudInnerStorageFetcher<IForm>('EntryId', {
          formId: 350,
          code: 'Push Day Outcome',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.PushDayOutcome
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new CrudInnerStorageFetcher<IForm>('EntryID', {
          formId: 261,
          code: CrudStoreItem.PartnerContacts,
        }),
        keyField: 'EntryID',
      }),
      CrudStoreItem.PartnerContacts
    )
    CrudStore.add(
      new Crud<I2029Form>({
        fetcher: new CrudInnerStorageFetcher<I2029Form>('EntryId', {
          formId: 2029,
          code: CrudStoreItem.CallLogs,
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.CallLogs
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new CrudInnerStorageFetcher<IForm>('EntryId', {
          formId: 424,
          code: 'PostalCode_and_TaxId_validation_rules',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 2000,
        },
      }),
      CrudStoreItem.ValidationRules
    )
    CrudStore.add(
      new Crud<IFormPartnerFlagsRequests>({
        fetcher: new CrudInnerStorageFetcher<IFormPartnerFlagsRequests>('EntryId', {
          formId: 519,
          code: 'PartnerFlagsRequests',
        }),
        keyField: 'EntryId',
        connectorCreateFn: async (code: string, items: IForm[]): Promise<IForm[]> => {
          const crud = CrudStore.get(CrudStoreItem.PartnerFlagsRequests)
          crud.removeQueries()
          return items
        },
      }),
      CrudStoreItem.PartnerFlagsRequests
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new CrudInnerStorageFetcher<IForm>('EntryId', {
          formId: 414,
          code: 'CountryProvinceNames',
        }),
        keyField: 'EntryId',
        connectorCreateFn: async (code: string, items: IForm[]): Promise<IForm[]> => {
          const crud = CrudStore.get(CrudStoreItem.CountryProvinceNames)
          crud.removeQueries()
          return items
        },
      }),
      CrudStoreItem.CountryProvinceNames
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new CrudInnerStorageFetcher<IForm>('CTRY_SB_DVSN_CD', {
          formId: 414,
          code: 'CountryProvinceNames',
        }),
        keyField: 'CTRY_SB_DVSN_CD',
      }),
      CrudStoreItem.CountryStatesDropdown
    )
    CrudStore.add(
      new Crud<IFormSalesTeam>({
        fetcher: new CrudInnerStorageFetcher<IFormSalesTeam>('EntryId', {
          formId: 606,
          code: 'SalesTeamCoverageRegion',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 100,
        },
      }),
      CrudStoreItem.SalesTeamCoverage
    )
    CrudStore.add(
      new Crud<IFormSalesTeam>({
        fetcher: new CrudInnerStorageFetcher<IFormSalesTeam>('EntryId', {
          formId: 606,
          code: 'WW_SalesTeam_RollDown',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItem.SalesTeamRollDown
    )
    CrudStore.add(
      new Crud<IFormSalesTeam>({
        fetcher: new CrudInnerStorageFetcher<IFormSalesTeam>('EntryId', {
          formId: 606,
          code: 'bp-overview-sales-agent-view',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItem.BPOverviewSalesAgent
    )
    CrudStore.add(
      new Crud<ISalesTeamPBMsListView>({
        fetcher: new CrudInnerStorageFetcher<ISalesTeamPBMsListView>('EntryId', {
          formId: 606,
          code: 'WW_SalesTeamPBMsList',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItem.SalesTeamMngm
    )
    CrudStore.add(
      new Crud<I871Form>({
        fetcher: new CrudInnerStorageFetcher<I871Form>('EntryId', {
          formId: 871,
          code: 'sales-team-master-data-871',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItem.SalesTeamSRM
    )
    CrudStore.add(
      new Crud<ISalesTeamRequestsView>({
        fetcher: new CrudInnerStorageFetcher<ISalesTeamRequestsView>('EntryId', {
          formId: 886,
          code: 'SalesTeamRequests',
        }),
        keyField: 'EntryId',
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItem.SalesTeamRequests
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new CrudInnerStorageFetcher<IForm>('EntryId', {
          formId: 638,
          code: 'PreferredContacts',
        }),
        keyField: 'EntryId',
        connectorCreateFn: async (code: string, items: IForm[]): Promise<IForm[]> => {
          const crud = CrudStore.get(CrudStoreItem.PreferredContacts)
          crud.removeQueries()
          return items
        },
      }),
      CrudStoreItem.PreferredContacts
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new SearchAPIFetcher<IForm>('EntryID', { type: SearchRequestType.Partner }),
        keyField: 'EntryID',
        skipPagingTransform: true,
      }),
      CrudStoreItem.SearchAPIPartner
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new SearchAPIFetcher<IForm>('EntryID', { type: SearchRequestType.Contact }),
        keyField: 'EntryID',
        skipPagingTransform: true,
      }),
      CrudStoreItem.SearchAPIContact
    )
    CrudStore.add(
      new Crud({
        keyField: 'partner_id',
        fetcher: new BusinessOpportunityFinderApiFetcher(),
        skipPagingTransform: true,
        defaultPaging: {
          pageSize: 20,
          page: 0,
        },
      }),
      CrudStoreItem.BusinessOpportunityFinder
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('lead_pbm', {
          formId: 621,
          code: 'lead_pbm_list_from_opportunity_finder',
        }),
        keyField: 'lead_pbm',
        defaultPaging: {
          pageSize: 20,
          page: 0,
        },
      }),
      CrudStoreItem.BOF_leadPBM_list
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('partner_id', {
          formId: 621,
          code: 'partners_list_from_opportunity_finder',
        }),
        keyField: 'partner_id',
        defaultPaging: {
          pageSize: 20,
          page: 0,
        },
      }),
      CrudStoreItem.BOF_partners_list
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('rad_vertical', {
          formId: 621,
          code: 'industry_list_from_opportunity_finder',
        }),
        keyField: 'rad_vertical',
        defaultPaging: {
          pageSize: 100,
          page: 0,
        },
      }),
      CrudStoreItem.BOF_industry_list
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new CrudInnerStorageFetcher<IForm>('EntryId', {
          formId: 422,
          code: 'PartnerLandscape',
        }),
        keyField: 'EntryID',
      }),
      CrudStoreItem.PartnerLandscape
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new CrudInnerStorageFetcher<IForm>('EntryId', {
          formId: 421,
          code: 'SWOT_Analysis',
        }),
        keyField: 'EntryID',
      }),
      CrudStoreItem.SWOT_Analysis
    )
    CrudStore.add(
      new Crud<IFormLeadAbout>({
        fetcher: new CrudInnerStorageFetcher<IFormLeadAbout>('EntryId', {
          formId: 520,
          audience: true,
          code: 'LeadAbout',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.LeadAbout
    )
    CrudStore.add(
      new Crud<IThirdPartyDetailReport>({
        fetcher: new CrudInnerStorageFetcher<IThirdPartyDetailReport>('UniqueId', {
          formId: 647,
          code: 'ThirdPartyDetailReport',
        }),
        keyField: 'UniqueId',
      }),
      CrudStoreItem.PartyDetailReport
    )
    CrudStore.add(
      new Crud<IAgreementReportView>({
        fetcher: new CrudInnerStorageFetcher<IAgreementReportView>('AGREE_NUM', {
          formId: 647,
          code: 'agreement_report',
        }),
        keyField: 'AGREE_NUM',
      }),
      CrudStoreItem.AgreementReport
    )
    CrudStore.add(
      new Crud<IFormStatusOverall>({
        fetcher: new CrudInnerStorageFetcher<IFormStatusOverall>('RFBID', {
          formId: 654,
          code: 'PFE_StatusOverall',
        }),
        keyField: 'RFBID',
      }),
      CrudStoreItem.PFE_StatusOverall
    )
    CrudStore.add(
      new Crud<IFormStatusAccred>({
        fetcher: new CrudInnerStorageFetcher<IFormStatusAccred>('RFBID', {
          formId: 655,
          code: 'PFE_StatusAccred',
        }),
        keyField: 'RFBID',
      }),
      CrudStoreItem.PFE_StatusAccred
    )
    CrudStore.add(
      new Crud<IFormStatusRevenue>({
        fetcher: new CrudInnerStorageFetcher<IFormStatusRevenue>('RFBID', {
          formId: 656,
          code: 'PFE_StatusRevenue',
        }),
        keyField: 'RFBID',
      }),
      CrudStoreItem.PFE_StatusRevenue
    )
    CrudStore.add(
      new Crud<IFormStatusCert>({
        fetcher: new CrudInnerStorageFetcher<IFormStatusCert>('RFBID', {
          formId: 657,
          code: 'PFE_StatusCert',
        }),
        keyField: 'RFBID',
      }),
      CrudStoreItem.PFE_StatusCertification
    )
    CrudStore.add(
      new Crud<IFormStatusCertEmp>({
        fetcher: new CrudInnerStorageFetcher<IFormStatusCertEmp>('RFBID', {
          formId: 658,
          code: 'PFE_StatusCertEmp',
        }),
        keyField: 'RFBID',
      }),
      CrudStoreItem.PFE_StatusCertEmp
    )
    CrudStore.add(
      new Crud<IFormCertification>({
        fetcher: new CrudInnerStorageFetcher<IFormCertification>('RFBID', {
          formId: 659,
          code: 'PFE_CertDisplayname',
        }),
        keyField: 'RFBID',
      }),
      CrudStoreItem.PFE_CertDisplayname
    )
    CrudStore.add(
      new Crud<IFormStatusOther>({
        fetcher: new CrudInnerStorageFetcher<IFormStatusOther>('RFBID', {
          formId: 660,
          code: 'PFE_StatusOther',
        }),
        keyField: 'RFBID',
      }),
      CrudStoreItem.PFE_StatusOther
    )
    CrudStore.add(
      new Crud<ILegalAttachment>({
        fetcher: new CrudInnerStorageFetcher<ILegalAttachment>('EntryId', {
          formId: 672,
          code: 'LegalAttachments',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.LegalAttachments
    )
    CrudStore.add(
      new Crud<IAttachment>({
        fetcher: new CrudInnerStorageFetcher<IAttachment>('EntryId', {
          formId: 2061,
          code: CrudStoreItem.CampaignAttachments,
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.CampaignAttachments
    )
    CrudStore.add(
      new Crud<IAttachment>({
        fetcher: new CrudInnerStorageFetcher<IAttachment>('EntryId', {
          formId: 2087,
          code: CrudStoreItem.CampaignReminders,
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.CampaignReminders
    )
    CrudStore.add(
      new Crud<IPartnersExt>({
        fetcher: new CrudInnerStorageFetcher<IPartnersExt>('EntryId', {
          formId: 406,
          code: 'PartnerAuditTrail',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.PartnerLog
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new CrudInnerStorageFetcher<IFormPartners>('EntryId', {
          formId: 502,
          code: 'PartnerLegalAuditTrail',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.PartnerLegalExtendLog
    )
    CrudStore.add(
      new Crud<IPartnerCodeLog>({
        fetcher: new CrudInnerStorageFetcher<IPartnerCodeLog>('EntryId', {
          formId: 559,
          code: 'PartnerFlagsRequestsLog',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.PartnerCodeLog
    )
    CrudStore.add(
      new Crud<IContactCodeLog>({
        fetcher: new CrudInnerStorageFetcher<IContactCodeLog>('EntryId', {
          formId: 560,
          code: 'ContactCodesRequestsLog',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.ContactCodeLog
    )
    CrudStore.add(
      new Crud<IContactsExt>({
        fetcher: new CrudInnerStorageFetcher<IContactsExt>('EntryId', {
          formId: 375,
          code: 'ContactAuditTrail',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.ContactsLog
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new CrudInnerStorageFetcher<IForm>('EntryId', {
          formId: 551,
          code: 'LocatorLog',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.LocatorLog
    )
    CrudStore.add(
      new Crud<IToDoWidgetData>({
        fetcher: new CrudInnerStorageFetcher<IToDoWidgetData>('PartnerId', {
          formId: 336,
          code: 'ToDoWidgetData',
        }),
        keyField: 'PartnerId',
      }),
      CrudStoreItem.ToDoWidgetData
    )
    CrudStore.add(
      new Crud<IFormComments>({
        fetcher: new CrudInnerStorageFetcher<IFormComments>('EntryId', {
          formId: 341,
          code: 'Comments',
        }),
        defaultPaging: {
          page: 0,
          pageSize: 1000,
        },
        defaultSort: { field: 'EntryId', dir: 'desc' },
        keyField: 'EntryId',
      }),
      CrudStoreItem.Comments
    )
    CrudStore.add(
      new Crud<ICoverage>({
        fetcher: new CrudInnerStorageFetcher<ICoverage>('EntryId', {
          formId: 336,
          code: 'my_coverage_table_mss',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.MyCoverage
    )
    CrudStore.add(
      new Crud<IFetchResult<any>>({
        fetcher: new CrudInnerStorageFetcher<IFetchResult<any>>('EntryId', {
          formId: 517,
          code: 'PartnerToDoFlags',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.PartnerToDoFlags
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new Static<IForm>([]),
        keyField: 'PartnerID',
      }),
      CrudStoreItem.SearchResultPartners
    )
    CrudStore.add(
      new Crud<IFormPartners>({
        fetcher: new CrudInnerStorageFetcher<IFormPartners>('EntryId', {
          formId: 261,
          code: 'CnGMaintenanceInfo',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.CnGMaintenanceInfo
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new CrudInnerStorageFetcher<IForm>('Campaign', {
          formId: 261,
          code: 'ListCampaigns',
        }),
        keyField: 'Campaign',
      }),
      CrudStoreItem.ListCampaigns
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new CrudInnerStorageFetcher<IForm>('EntryId', {
          formId: 379,
          code: 'ContactAdditionalInfo',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.ContactAdditionalInfo
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new CrudInnerStorageFetcher<IForm>('EntryId', {
          formId: 423,
          code: 'CampaignPartnerAssignment',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.CampaignPartnerAssignment
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new CrudInnerStorageFetcher<IForm>('EntryId', {
          formId: 688,
          code: 'HPAmplifyRegistration',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.RegistraionForm
    )
    CrudStore.add(
      new Crud<ILogForm>({
        fetcher: new CrudInnerStorageFetcher<ILogForm>('Id', {
          formId: 423,
          code: 'LOG_FORM_423',
        }),
        keyField: 'Id',
        defaultSort: { field: 'DateTime', dir: 'desc' },
        defaultPaging: {
          page: 0,
          pageSize: 100,
        },
      }),
      CrudStoreItem.NegotiableHistory
    )
    CrudStore.add(
      new Crud<IRegistrationData>({
        fetcher: new CrudInnerStorageFetcher<IRegistrationData>('ID', {
          formId: 449,
          code: 'Reg_Dashboard',
        }),
        keyField: 'ID',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.Reg_Dashboard
    )
    CrudStore.add(
      new Crud<ILogForm>({
        fetcher: new CrudInnerStorageFetcher<ILogForm>('Campaign', {
          formId: 261,
          code: 'CSI Summary Info User',
        }),
        keyField: 'Campaign',
      }),
      CrudStoreItem.CSISummaryInfoUser
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('Id', {
          formId: 458,
          code: 'PartnerSecurimates',
        }),
        keyField: 'Id',
      }),
      CrudStoreItem.SecurimatePartners
    )
    CrudStore.add(
      new Crud({
        // TODO: Temporary type definition. Need to replace any with actual type.
        fetcher: new ProcedureInnerStorageFetcher<any>('EntryId', {
          readFromTo: async (filter) => {
            let requestId
            const requestIdCondition = filter.filters.find(
              (i) => isFilter(i) && i.field === 'RequestId'
            )
            const partnerIdCondition = filter.filters.find(
              (i) => isFilter(i) && i.field === 'PartnerId'
            )

            if (
              !(
                partnerIdCondition &&
                isFilter(partnerIdCondition) &&
                typeof partnerIdCondition.value === 'string' &&
                partnerIdCondition.value
              )
            ) {
              return { Data: [] }
            }
            if (
              requestIdCondition &&
              isFilter(requestIdCondition) &&
              typeof requestIdCondition.value === 'number' &&
              requestIdCondition.value
            ) {
              requestId = requestIdCondition.value
            }
            const response = await thirdPartyLogsApi.fetchType(partnerIdCondition.value, requestId)

            return { Data: response.data.type ? [response.data.type] : [] }
          },
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.ThirdPartyType
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('Id', {
          formId: 458,
          code: 'PartnerAdditionalInfo',
        }),
        keyField: 'Id',
      }),
      CrudStoreItem.SecurimatePartnersFetch
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 458,
          code: 'PartnerAdditionalInfo',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.PartnerAdditionalInfo
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('PartnerID', {
          formId: 458,
          code: 'PolyPartnerList',
        }),
        keyField: 'PartnerID',
      }),
      CrudStoreItem.PolyPartnerList
    )
    CrudStore.add(
      new Crud<IFormProfileExt>({
        fetcher: new CrudInnerStorageFetcher<IFormProfileExt>('EntryId', {
          formId: 375,
          code: 'ContactExtData',
        }),
        keyField: 'EntryId',
        connectorCreateFn: (formId: string, items: IForm[]) =>
          CrudConnectors.createData(formId, items, CrudStoreItem.ContactExtData),
      }),
      CrudStoreItem.ContactExtData
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('PartnerId', {
          formId: 577,
          code: 'Current_CE_WW_AMP_View',
        }),
        keyField: 'PartnerId',
      }),
      CrudStoreItem.PartnerSuppliesPricingFlags
    )
    CrudStore.add(
      new Crud<IPartnerActualData>({
        fetcher: new CrudInnerStorageFetcher<IPartnerActualData>('EntryId', {
          formId: 406,
          code: 'PartnerActualData',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.PartnerActualData
    )
    CrudStore.add(
      new Crud<IToDoWidgetData>({
        fetcher: new CrudInnerStorageFetcher<IToDoWidgetData>('PartnerId', {
          formId: 840,
          code: 'ToDoWidgetDataLogs',
        }),
        keyField: 'PartnerId',
      }),
      CrudStoreItem.ToDoWidgetDataLogs
    )
    CrudStore.add(
      new Crud<ISustainabilityPlan>({
        fetcher: new CrudInnerStorageFetcher<ISustainabilityPlan>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.SustainabilityPlan)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.SustainabilityPlan
    )

    CrudStore.add(
      new Crud<ISustainabilityPlanItems>({
        fetcher: new CrudInnerStorageFetcher<ISustainabilityPlanItems>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.SustainabilityPlanItems)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.SustainabilityPlanItems
    )
    CrudStore.add(
      new Crud<IImpactPledge>({
        fetcher: new CrudInnerStorageFetcher<IImpactPledge>('EntryId', {
          formId: 769,
          code: 'HPAmplifyImpactPledge',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.ImpactPledge
    )
    CrudStore.add(
      new Crud<IImpactPledge>({
        fetcher: new CrudInnerStorageFetcher<IImpactPledge>('EntryId', {
          formId: 929,
          code: 'impact-pledge-929',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.ImpactPledge22
    )
    CrudStore.add(
      new Crud<IImpactAssessment>({
        fetcher: new CrudInnerStorageFetcher<IImpactAssessment>('EntryId', {
          formId: 777,
          code: 'impact-assessment-hp-report',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.ImpactAssessment
    )
    CrudStore.add(
      new Crud<IImpactAssessment>({
        fetcher: new CrudInnerStorageFetcher<IImpactAssessment>('EntryId', {
          formId: 930,
          code: 'impact-assessment-hp-report-22',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.ImpactAssessment22
    )
    CrudStore.add(
      new Crud<IActivityLog>({
        fetcher: new CrudInnerStorageFetcher<IActivityLog>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.SustainabilityActivityLogs)
        ),
        defaultSort: {
          field: 'EntryId',
          dir: 'asc',
        },
        defaultPaging: {
          page: 0,
          pageSize: 100,
        },
        keyField: 'EntryId',
      }),
      CrudStoreItem.SustainabilityActivityLogs
    )
    CrudStore.add(
      new Crud<ISustainabilityAttachment>({
        fetcher: new CrudInnerStorageFetcher<ISustainabilityAttachment>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.SustainabilityAttachments)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.SustainabilityAttachments
    )

    CrudStore.add(
      new Crud<IExecutiveSponsorshipFormM01>({
        fetcher: new CrudInnerStorageFetcher<IExecutiveSponsorshipFormM01>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.ExecutiveSponsorshipFormM01)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.ExecutiveSponsorshipFormM01
    )
    CrudStore.add(
      new Crud<ISustainableProcurementFormM02>({
        fetcher: new CrudInnerStorageFetcher<ISustainableProcurementFormM02>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.SustainableProcurementM02)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.SustainableProcurementM02
    )
    CrudStore.add(
      new Crud<IPrintFleetAssessmentFormM09>({
        fetcher: new CrudInnerStorageFetcher<IPrintFleetAssessmentFormM09>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.PrintFleetAssessmentM09)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.PrintFleetAssessmentM09
    )
    CrudStore.add(
      new Crud<ISustainabilityDealFormM07>({
        fetcher: new CrudInnerStorageFetcher<ISustainabilityDealFormM07>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.SustainabilityDealFormM07)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.SustainabilityDealFormM07
    )
    CrudStore.add(
      new Crud<IComRepFormM05>({
        fetcher: new CrudInnerStorageFetcher<IComRepFormM05>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.CommunicationsReportingFormM05)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.CommunicationsReportingFormM05
    )
    CrudStore.add(
      new Crud<ICustomerAwarenessFormM11>({
        fetcher: new CrudInnerStorageFetcher<ICustomerAwarenessFormM11>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.CustomerAwarenessFormM11)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.CustomerAwarenessFormM11
    )
    CrudStore.add(
      new Crud<IMarketingCampaignFormM11_1>({
        fetcher: new CrudInnerStorageFetcher<IMarketingCampaignFormM11_1>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.MarketingCampaignFormM111)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.MarketingCampaignFormM111
    )
    CrudStore.add(
      new Crud<IOfficeRecyclingFormM14>({
        fetcher: new CrudInnerStorageFetcher<IOfficeRecyclingFormM14>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.OfficeRecyclingFormM14)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.OfficeRecyclingFormM14
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.CarbonFootprintActionM15)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.CarbonFootprintActionM15
    )
    CrudStore.add(
      new Crud<ISalesTeamTicketsView>({
        fetcher: new CrudInnerStorageFetcher<ISalesTeamTicketsView>('EntryId', {
          formId: 1217,
          code: 'SalesTeamTickets',
        }),
        keyField: 'EntryId',
        defaultPaging: { page: 0, pageSize: 10 },
        defaultSort: { field: 'EntryId', dir: 'desc' },
      }),
      CrudStoreItem.SalesTeamTickets
    )
    CrudStore.add(
      new Crud<IEnergyEfficiencyFormM16>({
        fetcher: new CrudInnerStorageFetcher<IEnergyEfficiencyFormM16>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.EnergyEfficiencyFormM16)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.EnergyEfficiencyFormM16
    )
    CrudStore.add(
      new Crud<IEmployeeWellBeingFormM21>({
        fetcher: new CrudInnerStorageFetcher<IEmployeeWellBeingFormM21>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.EmployeeWellBeingFormM21)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.EmployeeWellBeingFormM21
    )
    CrudStore.add(
      new Crud<IVolunteeringFormM22>({
        fetcher: new CrudInnerStorageFetcher<IVolunteeringFormM22>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.VolunteeringFormM22)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.VolunteeringFormM22
    )
    CrudStore.add(
      new Crud<ICommunityEngagementFormM24>({
        fetcher: new CrudInnerStorageFetcher<ICommunityEngagementFormM24>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.CommunityEngagementFormM24)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.CommunityEngagementFormM24
    )
    CrudStore.add(
      new Crud<IUserInitiativesForm>({
        fetcher: new CrudInnerStorageFetcher<IUserInitiativesForm>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.UserInitiativesForm)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.UserInitiativesForm
    )
    CrudStore.add(
      new Crud<IUserInitiativesForm>({
        fetcher: new CrudInnerStorageFetcher<IUserInitiativesForm>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.DEIStrategyFormM18)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.DEIStrategyFormM18
    )
    CrudStore.add(
      new Crud<IUserInitiativesForm>({
        fetcher: new CrudInnerStorageFetcher<IUserInitiativesForm>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.CustomerCaseStudiesM10)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.CustomerCaseStudiesM10
    )
    CrudStore.add(
      new Crud<IUserInitiativesForm>({
        fetcher: new CrudInnerStorageFetcher<IUserInitiativesForm>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.SustainabilityFormM13)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.SustainabilityFormM13
    )
    CrudStore.add(
      new Crud<IFormSalesTeamLogs>({
        fetcher: new CrudInnerStorageFetcher<IFormSalesTeamLogs>('EntryId', {
          formId: 886,
          code: 'SalesTeamLogs',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.SalesTeamLogs
    )
    CrudStore.add(
      new Crud<IWW_SalesTeamLogsWithChangesView>({
        fetcher: new CrudInnerStorageFetcher<IWW_SalesTeamLogsWithChangesView>('DateTime', {
          formId: 606,
          code: 'WW_SalesTeamLogsWithChanges',
        }),
        keyField: 'DateTime',
      }),
      CrudStoreItem.SalesTeamRecordLogs
    )
    CrudStore.add(
      new Crud<any>({
        fetcher: new CrudInnerStorageFetcher<IFormSalesTeamLogs>('EntryId', {
          formId: 915,
          code: 'AmplifyinsightRequests',
        }),
        defaultSort: {
          field: 'PartnerId',
          dir: 'asc',
        },
        keyField: 'EntryId',
      }),
      CrudStoreItem.AmplifyinsightRequests
    )
    CrudStore.add(
      new Crud<any>({
        fetcher: new CrudInnerStorageFetcher<IFormSalesTeamLogs>('EntryId', {
          formId: 915,
          code: 'AmplifyInsightExport',
        }),
        defaultSort: {
          field: 'PartnerId',
          dir: 'asc',
        },
        keyField: 'EntryId',
      }),
      CrudStoreItem.AmplifyInsightExport
    )
    CrudStore.add(
      new Crud<any>({
        fetcher: new CrudInnerStorageFetcher<IFormSalesTeamLogs>('Name', {
          formId: 917,
          code: 'amplify-insight-names-917',
        }),
        keyField: 'Name',
        defaultPaging: { page: 0, pageSize: 1000 },
      }),
      CrudStoreItem.AmplifyInsightNames
    )
    CrudStore.add(
      new Crud<any>({
        fetcher: new CrudInnerStorageFetcher<IFormSalesTeamLogs>('EntryId', {
          formId: 915,
          code: 'AmplifyInsightApprovers',
        }),
        keyField: 'EntryId',
        defaultPaging: { page: 0, pageSize: 1000 },
      }),
      CrudStoreItem.AmplifyInsightApprovers
    )
    CrudStore.add(
      new Crud<any>({
        fetcher: new CrudInnerStorageFetcher<IFormSalesTeamLogs>('EntryId', {
          formId: 915,
          code: 'AmplifyInsightRequestDetails',
        }),
        keyField: 'EntryId',
        defaultPaging: { page: 0, pageSize: 1000 },
      }),
      CrudStoreItem.AmplifyInsightRequestDetails
    )
    CrudStore.add(
      new Crud<IFormToolAccessPartnerFlags>({
        fetcher: new CrudInnerStorageFetcher<IFormToolAccessPartnerFlags>('UniqueId', {
          formId: 577,
          code: 'ToolAccessPartnerFlags',
        }),
        keyField: 'UniqueId',
        defaultPaging: { page: 0, pageSize: 1000 },
      }),
      CrudStoreItem.ToolAccessPartnerFlags
    )
    CrudStore.add(
      new Crud<IForm>({
        fetcher: new CrudInnerStorageFetcher<IForm>('EntryId', {
          formId: 955,
          code: 'ProfilingTicketsMentionedUsers',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.ProfilingTicketsMentionedUsers
    )
    CrudStore.add(
      new Crud<IFormProfilingAudience>({
        fetcher: new CrudInnerStorageFetcher<IFormProfilingAudience>('UniqueId', {
          formId: 955,
          code: 'ProfilingAudience',
        }),
        keyField: 'UniqueId',
      }),
      CrudStoreItem.ProfilingAudience
    )
    CrudStore.add(
      new Crud<IContactActual>({
        fetcher: new CrudInnerStorageFetcher<IContactActual>('EntryID', {
          formId: 261,
          code: 'ContactActualData',
        }),
        keyField: 'EntryID',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.ContactActualData
    )
    CrudStore.add(
      new Crud<IContactActual>({
        fetcher: new CrudInnerStorageFetcher<IContactActual>('PartnerID', {
          formId: 261,
          code: 'WW_Partners',
        }),
        keyField: 'PartnerID',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.WW_Partners
    )
    CrudStore.add(
      new Crud<IFormPartnersList>({
        fetcher: new CrudInnerStorageFetcher<IFormPartnersList>('PartnerID', {
          formId: 261,
          code: 'WW_PartnersList',
        }),
        keyField: 'PartnerID',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.WW_PartnersList
    )
    CrudStore.add(
      new Crud<IFormPartnersList>({
        fetcher: new CrudInnerStorageFetcher<IFormPartnersList>('EntryId', {
          formId: 1358,
          code: 'partner-creation-drafts-1358',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.PartnerDrafts
    )
    CrudStore.add(
      new Crud<IContactActual>({
        fetcher: new CrudInnerStorageFetcher<IContactActual>('EntryId', {
          formId: 576,
          code: 'WW_Contacts',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.WW_Contacts
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('PartnerId', {
          formId: 958,
          code: 'aiih-catalyst-poe-partners-list',
        }),
        keyField: 'PartnerId',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.CatalystList
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('PartnerId', {
          formId: 1441,
          code: 'ai-catalyst-poe-partners-list',
        }),
        keyField: 'PartnerId',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.CatalystList24
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('PartnerId', {
          formId: 1441,
          code: 'ai-catalyst-poe-partners-list-25',
        }),
        keyField: 'PartnerId',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.CatalystList25
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('UniqueKey', {
          formId: 958,
          code: 'aiih-catalyst-poe-list',
        }),
        keyField: 'UniqueKey',
        defaultPaging: {
          page: 0,
          pageSize: 3000,
        },
      }),
      CrudStoreItem.CatalystListDetail
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('UniqueKey', {
          formId: 1441,
          code: 'ai-catalyst-poe-list',
        }),
        keyField: 'UniqueKey',
        defaultPaging: {
          page: 0,
          pageSize: 3000,
        },
      }),
      CrudStoreItem.CatalystListDetailFY24
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 1228,
          code: 'impact-assessment-1228',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.ImpactAssessment1228
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 1416,
          code: 'impact-assessment-1416',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.ImpactAssessment1416
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 940,
          code: 'hp-recycle-data-940',
        }),
        keyField: 'EntryId',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.PlanetPartnerApproval
    )

    CrudStore.add(
      new Crud<ISustainabilityPlan>({
        fetcher: new CrudInnerStorageFetcher<ISustainabilityPlan>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.SustainabilityPlan23)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.SustainabilityPlan23
    )

    CrudStore.add(
      new Crud<ISustainabilityPlan>({
        fetcher: new CrudInnerStorageFetcher<ISustainabilityPlan>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.SustainabilityPlan24)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.SustainabilityPlan24
    )

    CrudStore.add(
      new Crud<ISustainabilityPlan>({
        fetcher: new CrudInnerStorageFetcher<ISustainabilityPlan>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.SustainabilityPlan25)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.SustainabilityPlan25
    )

    CrudStore.add(
      new Crud<ISustainabilityPlanItems>({
        fetcher: new CrudInnerStorageFetcher<ISustainabilityPlanItems>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.SustainabilityPlanItems23)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.SustainabilityPlanItems23
    )

    CrudStore.add(
      new Crud<ISustainabilityPlanItems>({
        fetcher: new CrudInnerStorageFetcher<ISustainabilityPlanItems>(
          'EntryId',
          GetSustainabilityFormKey(CrudStoreItem.SustainabilityPlanItems25)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItem.SustainabilityPlanItems25
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('UniqueId', {
          formId: 740,
          code: 'JBPMasterDealers',
        }),
        keyField: 'UniqueId',
      }),
      CrudStoreItem.JBPMasterDealers
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 740,
          code: CrudStoreItem.JBPMasterDealerData,
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.JBPMasterDealerData
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 740,
          code: CrudStoreItem.JBPMasterDealerExtendedPartners,
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.JBPMasterDealerExtendedPartners
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 740,
          code: 'MasterDealerExtendedPartners',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.JBPMasterDealerRelateToExtendedPartner
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 740,
          code: 'JBPMasterDealerEPAssignedToNonCompliantMD',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.JBPMasterDealerEPAssignedToNonCompliantMD
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 261,
          code: CrudStoreItem.ContactFlags,
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.ContactFlags
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 514,
          code: CrudStoreItem.ContactFlagRequests,
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.ContactFlagRequests
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 261,
          code: CrudStoreItem.ContactFlagsAllData,
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.ContactFlagsAllData
    )

    CrudStore.add(
      new Crud<IPartnerLnRStatusesView>({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 647,
          code: CrudStoreItem.PartnerLnRStatuses,
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.PartnerLnRStatuses
    )

    CrudStore.add(
      new Crud<I2079Form>({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 2079,
          code: CrudStoreItem.EngagementPrediction,
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.EngagementPrediction
    )

    CrudStore.add(
      new Crud<IDistributorsOnBehalfView>({
        fetcher: new CrudInnerStorageFetcher('PartnerId', {
          formId: 1538,
          code: CrudStoreItem.DistributorsOnBehalfList,
        }),
        keyField: 'PartnerId',
        defaultPaging: {
          page: 0,
          pageSize: 500,
        },
      }),
      CrudStoreItem.DistributorsOnBehalfList
    )

    CrudStore.add(
      new Crud({
        fetcher: new ProcedureInnerStorageFetcher('id', {
          readFromTo: async () => {
            const result = await roleApi.fetchAll()
            return { Data: result }
          },
        }),
        keyField: 'id',
      }),
      CrudStoreItem.Roles
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('GUID', {
          formId: 693,
          code: 'FormCollector',
        }),
        keyField: 'GUID',
      }),
      CrudStoreItem.FormCollector
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher<IForm>('Id', {
          formId: 495,
          code: 'AppUsersView',
        }),
        hierarchyRoot: null,
        keyField: 'Id',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.UsersView
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher<IForm>('Id', {
          formId: 495,
          code: 'AppUsersAppsSearch',
        }),
        keyField: 'Id',
        defaultFilter: {
          logic: Logic.AND,
          filters: [
            {
              field: 'AppId',
              operator: Operator.EQUAL,
              value: getAppId(),
            },
          ],
        },
        defaultPaging: {
          page: 0,
          pageSize: 5,
        },
      }),
      CrudStoreItem.AppUsersAppsSearch
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher<ICountryHierarchyInformation>('EntryId', {
          formId: 74,
          code: 'CountriesList',
        }),
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
        defaultSort: {
          field: 'EntryId',
          dir: 'desc',
        },
        keyField: 'EntryId',
      }),
      CrudStoreItem.CountriesTable
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher<IForm>('EntryId', {
          formId: 631,
          code: 'MappingRules',
        }),
        defaultPaging: {
          page: 0,
          pageSize: 500,
        },
        keyField: 'EntryId',
      }),
      CrudStoreItem.ExcelMapping
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher<IForm>('EntryId', {
          formId: 632,
          code: 'CellFormat',
        }),
        defaultPaging: {
          page: 0,
          pageSize: 100,
        },
        keyField: 'EntryId',
      }),
      CrudStoreItem.ExcelCellFormat
    )
    CrudStore.add(
      new Crud<I678Form>({
        fetcher: new CrudInnerStorageFetcher<I678Form>('EntryID', {
          formId: 678,
          code: 'WW_REF_ID',
        }),
        keyField: 'EntryID',
      }),
      CrudStoreItem.WW_REF_ID
    )
    CrudStore.add(
      // TEMPORARY -> will be deleted.
      new Crud<any>({
        fetcher: new CrudInnerStorageFetcher<any>('EntryId', {
          formId: 678,
          code: 'PartnerRefIDs',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.PartnerRefIDs
    )
    CrudStore.add(
      // TEMPORARY -> will be deleted.
      new Crud<any>({
        fetcher: new CrudInnerStorageFetcher<any>('EntryId', {
          formId: 880,
          code: 'refidext-880',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.PartnerRefIDsRequests
    )
    CrudStore.add(
      new Crud<I2010Form>({
        fetcher: new CrudInnerStorageFetcher<I2010Form>('EntryId', {
          formId: 2010,
          code: 'app-internal-notifications-2010',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.AppNotifications
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher<I495Form>('EntryId', {
          formId: 495,
          code: 'cng-organization-chart',
        }),
        hierarchyRoot: null,
        keyField: 'Id',
        defaultPaging: {
          page: 0,
          pageSize: 10,
        },
      }),
      CrudStoreItem.OrganizationChart
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher<I2081Form>('EntryId', {
          formId: 2081,
          code: CrudStoreItem.MDMAutoFlaggingRules,
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItem.MDMAutoFlaggingRules
    )

    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher<I2081Form>('EntryId', {
          formId: 2082,
          code: CrudStoreItem.MDAdditionalInfo,
        }),
        keyField: 'MDPartnerId',
      }),
      CrudStoreItem.MDAdditionalInfo
    )
  }
}

export default new InitializationService()
